/** Compact counts for engagement chrome (4.1k style). */
export function formatCompactCount(count: number): string {
  const n = Number.isFinite(count) ? Math.max(0, Math.floor(count)) : 0;
  if (n >= 1_000_000) {
    const v = n / 1_000_000;
    return `${v >= 10 ? Math.round(v) : v.toFixed(1).replace(/\.0$/, '')}M`;
  }
  if (n >= 1000) {
    const v = n / 1000;
    return `${v >= 10 ? Math.round(v) : v.toFixed(1).replace(/\.0$/, '')}k`;
  }
  return String(n);
}

/** Secondary text line: "1,284 views · 447 likes · 46 favorites" */
export function formatEngagementMeta(
  viewCount: number,
  favoriteCount: number,
  likeCount?: number
): string {
  const views = Number.isFinite(viewCount) ? Math.max(0, Math.floor(viewCount)) : 0;
  const favorites = Number.isFinite(favoriteCount) ? Math.max(0, Math.floor(favoriteCount)) : 0;
  const likes =
    likeCount === undefined || likeCount === null
      ? null
      : Number.isFinite(likeCount)
        ? Math.max(0, Math.floor(likeCount))
        : 0;

  const parts = [
    `${views.toLocaleString()} ${views === 1 ? 'view' : 'views'}`,
  ];
  if (likes !== null) {
    parts.push(`${likes.toLocaleString()} ${likes === 1 ? 'like' : 'likes'}`);
  }
  parts.push(`${favorites.toLocaleString()} ${favorites === 1 ? 'favorite' : 'favorites'}`);
  return parts.join(' · ');
}
